// 颜色hex转rgb分量
export const hexToRgb = (hex: string) => {
  if (!hex) return '';

  // 去除 # 号
  hex = hex.replace(/^#/, '');

  // 处理缩写形式（如 #FFF → FFFFFF）
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map(c => c + c)
      .join('');
  }

  // 提取 R, G, B 分量并转为十进制
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `${r}, ${g}, ${b}`;
};

/**
 * 根据渐变起止颜色和百分比计算中间色值
 * @param {string} startColor - 起始颜色（HEX格式，如 #FF6C52）
 * @param {string} endColor   - 结束颜色（HEX格式，如 #FFF38F）
 * @param {number} percent    - 百分比（0~100）
 * @returns {string} 计算后的 HEX 颜色值
 */
export const getGradientColor = (startColor: string, endColor: string, percent: number) => {
  if (!(startColor && endColor)) return '';

  // 将 HEX 颜色解析为 RGB 分量
  const hexToRgb = (hex: string) => {
    hex = hex.replace(/^#/, '');
    if (hex.length === 3)
      hex = hex
        .split('')
        .map(c => c + c)
        .join('');
    return [parseInt(hex.substring(0, 2), 16), parseInt(hex.substring(2, 4), 16), parseInt(hex.substring(4, 6), 16)];
  };

  // 获取起止颜色的 RGB 分量
  const start = hexToRgb(startColor);
  const end = hexToRgb(endColor);

  // 约束百分比在 0~100 范围内
  const p = Math.min(100, Math.max(0, percent)) / 100;

  // 线性插值计算每个颜色通道的值
  const interpolate = (s: number, e: number) => Math.round(s + (e - s) * p);

  const r = interpolate(start[0], end[0]);
  const g = interpolate(start[1], end[1]);
  const b = interpolate(start[2], end[2]);

  // 将 RGB 分量转回 HEX 格式
  const toHex = (n: number) => n.toString(16).padStart(2, '0').toUpperCase();
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};
